type TabKeysMappings = {
  [key: string]: string;
};

export const tabKeysMappings: TabKeysMappings = {
  '1': '[id="tab-Produtos (Alt + 1)"]',
  '2': '[id="tab-Finalização (Alt + 2)"]',
};
